import { Component, Input, OnInit } from '@angular/core';
import { IBillingDocument } from '@dch/billing-business-logic';

@Component({
  selector: 'my-bill-odb-page-base-structure',
  templateUrl: './odb-page-base-structure.component.html',
  standalone: false,
})
export class OdbPageBaseStructureComponent implements OnInit {
  @Input() billingDocument: IBillingDocument;
  @Input() hasCommonHeader?: boolean;
  @Input() hasCustomHeader?: boolean;
  @Input() shouldGoBackToOverview?: boolean;
  @Input() hasTopContent?: boolean;
  @Input() hasBottomContent?: boolean;
  @Input() leftColumnClassWidth?: string;
  @Input() rightColumnClassWidth?: string;
  @Input() customTitle = '';

  leftColumnWidth: string;
  rightColumnWidth: string;

  ngOnInit() {
    this.leftColumnWidth = this.leftColumnClassWidth ?? 'medium-7';
    this.rightColumnWidth = this.rightColumnClassWidth ?? 'medium-5';
  }
}
